<template>
	 <div id="customizeTwoGifts" class="customizeTwoGifts" >

		 <div class=" py-5 memberJackets_section">
			 <div class="content_container">
				 <SectionHeader subTitle="CUSTOMIZE YOUR BENEFITS" topText="EXCLUSIVE ISLES" middleText=" THEMED GIFTS" textColor="orange" textAlign="center"/>

				 <div class="content">
					 <p>
						 Members will be able to choose one (1) gift from the list below for each seat on your Membership account.
				     </p>
				 </div>
			 </div>
			 <div class="optionWrapper">
				 <div class="grid">
					 <!-- @click="onSelect(index)" -->
					 <div
					 class="grid_item"
					 v-for="(option, index) in options"
					 :key="index"

					 >
					 	<div class="img_checkbox">
							  <span class="box-box-box" >
						        <img
						  	      :src="require(`@/assets/images/benefits/${option.img}`)"
						          alt="check"
						        />
						      </span>

						      <h2 class="title">{{ option.title }}</h2>
							  <p>{{option.description}}</p>

						  </div>

				 	</div>
			 	</div>


		 	</div>

		 </div>
	 </div>
</template>

<script>

import SectionHeader from "@/components/SectionHeader";
export default {
  name: "CustomizeGifts",
  components: { SectionHeader },

  data() {
	   return {
		 modalActive: false,
		 options:
		 [
			{
				title: "Cooler Backpack",
				description: "An Isles-themed cooler bag to keep your favorite beverages nice and cold.",
				img: "gift-cooler.svg",
			},
			{
				title: "Laptop Bag",
				description: "Arrive to work (or work from home) in style with an Isles-themed laptop bag.",
				img: "gift-laptop.svg",
			},
			{
				title: "Adjustable Hat",
				description: "Show off your fandom with this exclusive NYI baseball hat just for Season Ticket Members.",
				img: "gift-hat.svg",
			},
			{
				title: "Children’s Lunch Tin",
				description: "Pack a lunch in this Isles-themed lunch tin.",
				img: "gift-lunch.svg",
			},
			{
				title: "Mittens",
				description: "Keep your hands warm on game day with Isles-themed mittens.",
				img: "gift-mittens.svg",
			},
			{
				title: "Isles Branded Blanket",
				description: "Wrap yourself in this comfortable Isles themed blanket.",
				img: "gift-blanket.svg",
			},
		 ],
	   };
	 },




};
</script>

<style lang="scss" scoped>
.customizeTwoGifts{
	padding: 50px 0;
	background-size:cover !important;
	background-repeat: no-repeat !important;
	background: url("~images/benefits/bg-gifts.jpg");
	@media screen and (min-width: 1600px) {
		// background-size:cover !important;
	}
	@include media-breakpoint-down(sm) {
	  background-repeat: no-repeat;
	  background-size:cover !important;
	}
	.memberJackets_section{

		@include media-breakpoint-down(sm) {

	    }
		.content_container{

			@include media-breakpoint-down(sm) {
				// padding-left: 50px;
				// text-align: center;
			}
			.content{
				max-width:575px;
				margin: 30px auto;
				@include media-breakpoint-down(sm) {
					padding: 0px 30px;
				}
			}

			p{
			  color: theme-var($--ch-theme-secondary);
			  font-family: "GeogrotesqueSharp-Md";
	  		  font-size: 18.5px;
	  		  letter-spacing: 0;
	  		  line-height: 140%;
			  text-align:center;
	  		  font-weight: 500;

			}
		}
		.img_container{
			position: relative;
			margin-bottom: 30px;

			@include media-breakpoint-down(sm) {
				margin-top: 30px;
			}

			.player_img {
				height:350px;
				// position: relative;
				margin-left: 170px;
				// top: 80px;
				// left: 185px;
				z-index:10;
				// box-shadow: 5px 5px 20px #aaaaaa;
				@include media-breakpoint-down(sm) {
			      height:275px;
				  margin-left: 35px;
			    }
			}
			    // flex-direction: column;

		}

	}
	.optionWrapper{
		padding:10px 30px;
		@include media-breakpoint-down(sm) {
		  // grid-template-columns: repeat(1, 0fr);
		   padding:10px;
		   // justify-content: center;
		  // align-items:  flex-start;
		}
		.grid{
			display: flex;
			flex-wrap: wrap;
			justify-content: center;
	   		align-items:  flex-start;
			padding:0px 100px;
			  @include media-breakpoint-down(sm) {
			    // grid-template-columns: repeat(1, 0fr);
			     padding:10px;
				 justify-content: center;
				align-items:  flex-start;
			  }
			  @media only screen and (min-width: 578px) and (max-width: 900px)  {
				  padding:10px;
				  align-items:  flex-start;
			   }
			.grid_item{
				flex: 0 0 33.33%;
			 	padding:20px 20px;
				margin: 10px;
				// opacity: 0.21;
				position:relative;
				border: 1px solid rgba(255,255,255,0.21);
			 	// background: rgba(0,0,0,0.54);
				@include media-breakpoint-down(sm) {
					flex: 0 0 45%;
					// flex-grow: 1;
		    	    padding: 10px 5px;
					margin: 10px 5px;
					// padding:20px 20px;
		  		    height: 230px;
				}
				@media only screen and (min-width: 578px) and (max-width: 900px)  {
					flex: 0 0 45%;
				 }
				 img{
 					margin-bottom:20px;
 					height:40px;
 					width:auto;
 					@include media-breakpoint-down(sm) {
 					  height:30px;
 					}
 					@media only screen and (min-width: 578px) and (max-width: 900px)  {
 						height:40px;
 					}
 				}
			 	h2{
					font-family: "GeogrotesqueSharp-Bd";
					font-size: 26px;
					color: theme-var($--ch-theme-on-primary);
					letter-spacing: 0;
					line-height: 34px;
					font-weight: 700;
					margin-bottom:20px;
					@include media-breakpoint-down(sm) {
					  font-size: 18px;
					  line-height: 24px;
					}
				}
				p{
					font-family: "GeogrotesqueSharp-Md";
					font-size: 18.5px;
					color: theme-var($--ch-theme-on-primary);
					letter-spacing: 0;
					line-height: 20px;
					font-weight: 500;
					@include media-breakpoint-down(sm) {
					  font-size: 14px;
					}
				}



			}
		}

	}
}
@media only screen and (min-width: 578px) and (max-width: 900px){
	.brickProgram{
		.memberJackets_section{
			flex-direction:column;
  		  flex-wrap: wrap;
		}
	}
}
</style>
